import { useNavigate } from 'react-router-dom';
import { Dropdown } from 'antd';
import { MoreHorizontal } from 'lucide-react';

import { useI18n } from '../../i18n';

export const RowActions = ({ items }) => {
  const navigate = useNavigate();
  const { t } = useI18n();
  const visible = items.filter(Boolean);
  if (!visible.length) return null;

  const menuItems = visible.map(item =>
    item.type === 'divider'
      ? item
      : {
          key: item.key,
          danger: item.danger,
          icon: item.icon ? <item.icon size={15} strokeWidth={1.75} /> : undefined,
          label: item.label,
          onClick: () => (item.to ? navigate(item.to) : item.onClick?.()),
        },
  );

  return (
    <Dropdown trigger={['click']} placement='bottomRight' menu={{ items: menuItems }}>
      <button type='button' className='wm-icon-btn' aria-label={t('common.actions')}>
        <MoreHorizontal size={17} strokeWidth={1.75} />
      </button>
    </Dropdown>
  );
};
